import { attachInboundBridge } from './inBoundMessage';
import { attachOutBoundBridge } from './outBoundMessage';

export const navigationBridge = {
  attachInbound: attachInboundBridge,
  attachOutbound: attachOutBoundBridge,
};
